export const apiDomain = 'https://api.t.atacloud.es/api/';
export const siteName = 'ATA';
export const login = apiDomain + '/login';
export const isDevelop = (process.env.NODE_ENV !== 'production');
